class HeroSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.hero-slider__slide'));
    this.dots = Array.from(this.querySelectorAll('.hero-slider__dot'));
    this.index = 0;

    if (this.slides.length < 2) return;

    this.interval = (parseFloat(this.dataset.interval) || 6) * 1000;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(Number(dot.dataset.index));
        this.restart();
      });
    });

    // Pause while the tab is hidden so slides don't race by in the background.
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.stop();
      else this.start();
    });

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!reduced.matches) this.start();
    reduced.addEventListener('change', (event) => {
      if (event.matches) this.stop();
      else this.start();
    });
  }

  disconnectedCallback() {
    this.stop();
  }

  start() {
    this.stop();
    this.timer = window.setInterval(() => this.next(), this.interval);
  }

  stop() {
    window.clearInterval(this.timer);
  }

  restart() {
    this.stop();
    this.start();
  }

  next() {
    this.goTo((this.index + 1) % this.slides.length);
  }

  goTo(nextIndex) {
    if (nextIndex === this.index) return;

    this.slides[this.index].classList.remove('is-active');
    this.slides[nextIndex].classList.add('is-active');

    if (this.dots.length) {
      this.dots[this.index].classList.remove('is-active');
      this.dots[this.index].setAttribute('aria-selected', 'false');
      this.dots[nextIndex].classList.add('is-active');
      this.dots[nextIndex].setAttribute('aria-selected', 'true');
    }

    this.index = nextIndex;
  }
}

customElements.define('hero-slider', HeroSlider);
